import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "static",
    boxShadow: "none",
    borderRadius: "0",
    minWidth: "100%",
  },
  toolBar: {
    height: 54,
    minHeight: 54,
    // Mobile only
    [theme.breakpoints.down("md")]: {
      marginTop: -7,
      marginBottom: 10,
      paddingTop: 15,
      paddingBottom: 15,
    },
  },
  formControl: {
    width: 200,
    maxWidth: 200,
    paddingRight: 10,
  },
  customSelect: {
    "& > select, & > div": {
      padding: "11px",
      zIndex: 9100,
    },
    borderRadius: 8,
  },
  mobileRoot: {
    margin: "7px 0 7px 16px",
  },
  mobileButtonContainer: {
    width: "100%",
    display: "flex",
    height: 42,
    alignItems: "center",
  },
  moreFiltersButton: {
    margin: "0 10px",
  },
  makeModelDropdown: {
    marginTop: 10,
    padding: 20,
    borderRadius: 16,
  },
  menuContentsContainer: {
    display: "flex",
    flexDirection: "column",
    width: 280,
    height: 200,
  },
  makeModelFormContainer: {
    "& > div": {
      width: "100%",
      marginTop: 28,
    },
    "& >div:nth-child(1)": {
      marginTop: 15,
    },
  },
  makeModelBottomContents: {
    display: "flex",
  },
  select: {
    marginBottom: 15,
    "& > div": {
      width: "100%",
      maxWidth: "100%",
    },
  },
}));
